import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';

// import error from '../assets/images/error.png';

class DeleteModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        console.log(this.props)
        return (

            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} >

                <ModalBody className="delete-modal">
                    {/* <img src={error} /> */}
                    <div className="message">
                        {
                            this.props.children
                        }
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="submit" color="danger" style={{ backgroundColor: "#F1646C" }} onClick={() => this.props.handler()}>DA</Button>{' '}
                    <Button type="submit" color="primary" style={{ backgroundColor: "#2196F3" }} onClick={() => this.props.toggle()} >NE</Button>{' '}
                </ModalFooter>
            </Modal>
        )
    }
}

export default DeleteModal;